import { useEffect, useRef, useState } from "react";
import {
  Container,
  DropdownItem,
  DropdownList,
  Label,
  SelectContainer,
} from "./localStyle";
import camelize from "global/utils/camelize";

const SelectDropdown = ({
  data,
  descripcion,
  placeholder,
  onChangeInput,
  styles,
  selectedValue,
}) => {
  const [selected, setSelected] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null); // Referencia al dropdown

  const handleSelect = (value, onClick) => {
    if (value[descripcion].toUpperCase() === selected.toUpperCase()) return; // Evitar seleccionar el mismo valor
    if (typeof value[descripcion] === "string") {
      setSelected(camelize(value[descripcion]));
    } else {
      setSelected(value[descripcion]);
    }
    setIsOpen(false);
    if (onClick) {
      onChangeInput(value);
    }
  };

  // Detectar clicks fuera del dropdown y cerrarlo
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  useEffect(() => {
    if (selectedValue) {
      handleSelect(selectedValue, false);
    }
  }, []);

  return (
    <Container
      ref={dropdownRef}
      $styles={styles}
      onClick={() => setIsOpen(!isOpen)}
    >
      <Label
        $isActive={isOpen || selected !== ""}
        $isSelected={!isOpen && selected !== ""}
        $isOpen={isOpen}
      >
        {placeholder}
      </Label>
      <SelectContainer $isOpen={isOpen} $isActive={isOpen && selected !== ""}>
        {isOpen && !selected ? "" : selected || placeholder}
      </SelectContainer>
      <DropdownList $isOpen={isOpen}>
        {data &&
          data.map((item, index) => {
            return (
              <DropdownItem
                key={index}
                onClick={() => handleSelect(item, true)}
              >
                {typeof item[descripcion] === "string"
                  ? camelize(item[descripcion])
                  : item[descripcion]}
              </DropdownItem>
            );
          })}
      </DropdownList>
    </Container>
  );
};

export default SelectDropdown;
